






import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class StarRating extends Vue
{
    @Prop({required: true}) score: number;
}
